import { DygraphData } from "../chart-types"

export const chartDataMock: DygraphData = {
  api: 1,
  id: "system.cpu",
  name: "system.cpu",
  view_update_every: 3,
  update_every: 1,
  first_entry: 1569922019,
  last_entry: 1569926015,
  before: 1569926013,
  after: 1569925714,
  dimension_names: [
    "user",
    "system",
  ],
  dimension_ids: [
    "user",
    "system",
  ],
  latest_values: [
    4.2446941,
    4.2446941,
  ],
  view_latest_values: [
    8.3417097,
    5.9647203,
  ],
  dimensions: 2,
  points: 100,
  format: "json",
  result: {
    labels: [
      "time",
      "user",
      "system",
    ],
    data: [
      [
        1569925716000,
        9.0216787,
        5.8058017,
      ],
      [
        1569925719000,
        6.9124407,
        5.4887107,
      ],
      [
        1569925722000,
        10.0159333,
        7.302166,
      ],
      [
        1569925725000,
        5.038882,
        3.6629967,
      ],
      [
        1569925728000,
        9.871115,
        6.8314217,
      ],
      [
        1569925731000,
        7.66808,
        5.4175577,
      ],
      [
        1569925734000,
        6.084593,
        4.4170903,
      ],
      [
        1569925737000,
        7.8007057,
        5.1712663,
      ],
      [
        1569925740000,
        6.4436253,
        4.740375,
      ],
      [
        1569925743000,
        8.293281,
        5.712848,
      ],
      [
        1569925746000,
        7.5741167,
        4.7469427,
      ],
      [
        1569925749000,
        7.9607517,
        6.4630373,
      ],
      [
        1569925752000,
        7.852998,
        4.8806767,
      ],
      [
        1569925755000,
        5.9964913,
        4.9136747,
      ],
      [
        1569925758000,
        6.9735743,
        3.7552497,
      ],
      [
        1569925761000,
        9.7016123,
        5.3308597,
      ],
      [
        1569925764000,
        5.7028263,
        3.4961553,
      ],
      [
        1569925767000,
        7.453964,
        4.8301603,
      ],
      [
        1569925770000,
        6.9693477,
        3.713083,
      ],
      [
        1569925773000,
        24.9587357,
        8.2498047,
      ],
      [
        1569925776000,
        10.046537,
        7.2947063,
      ],
      [
        1569925779000,
        4.58464,
        4.4954713,
      ],
      [
        1569925782000,
        9.0754477,
        4.912464,
      ],
      [
        1569925785000,
        6.087785,
        4.921636,
      ],
      [
        1569925788000,
        7.6217343,
        4.456521,
      ],
      [
        1569925791000,
        9.9676387,
        6.3395017,
      ],
      [
        1569925794000,
        16.2261653,
        5.706253,
      ],
      [
        1569925797000,
        61.7890567,
        12.0467377,
      ],
      [
        1569925800000,
        11.132041,
        7.0867343,
      ],
      [
        1569925803000,
        8.675336,
        6.211137,
      ],
      [
        1569925806000,
        7.650493,
        5.781459,
      ],
      [
        1569925809000,
        8.0524237,
        6.260554,
      ],
      [
        1569925812000,
        8.0792403,
        6.4974133,
      ],
      [
        1569925815000,
        4.4527673,
        3.329172,
      ],
      [
        1569925818000,
        6.374004,
        4.6244057,
      ],
      [
        1569925821000,
        7.3749613,
        3.7931873,
      ],
      [
        1569925824000,
        5.5105177,
        4.1729003,
      ],
      [
        1569925827000,
        5.6549653,
        4.409161,
      ],
      [
        1569925830000,
        6.284871,
        3.954967,
      ],
      [
        1569925833000,
        9.5447497,
        5.374101,
      ],
      [
        1569925836000,
        11.091343,
        4.839209,
      ],
      [
        1569925839000,
        10.3327137,
        13.085782,
      ],
      [
        1569925842000,
        8.7004603,
        8.5344997,
      ],
      [
        1569925845000,
        22.2665367,
        18.2045637,
      ],
      [
        1569925848000,
        17.01984,
        12.5140967,
      ],
      [
        1569925851000,
        22.8606813,
        13.4278807,
      ],
      [
        1569925854000,
        36.2928967,
        18.9365063,
      ],
      [
        1569925857000,
        43.6745733,
        20.188268,
      ],
      [
        1569925860000,
        19.89086,
        10.94626,
      ],
      [
        1569925863000,
        16.9658147,
        7.8018787,
      ],
      [
        1569925866000,
        10.433215,
        5.5478603,
      ],
      [
        1569925869000,
        9.2072543,
        5.3719357,
      ],
      [
        1569925872000,
        5.750251,
        3.9555027,
      ],
      [
        1569925875000,
        6.210993,
        4.2519293,
      ],
      [
        1569925878000,
        10.1033397,
        5.07409,
      ],
      [
        1569925881000,
        11.667133,
        6.5465067,
      ],
      [
        1569925884000,
        32.96155,
        12.7356787,
      ],
      [
        1569925887000,
        31.7063,
        17.0629963,
      ],
      [
        1569925890000,
        23.3469633,
        10.9301807,
      ],
      [
        1569925893000,
        24.9963733,
        10.140239,
      ],
      [
        1569925896000,
        20.0132213,
        9.9528523,
      ],
      [
        1569925899000,
        13.4464137,
        7.6851667,
      ],
      [
        1569925902000,
        10.7892063,
        6.1612827,
      ],
      [
        1569925905000,
        10.5275237,
        5.4097523,
      ],
      [
        1569925908000,
        6.70908,
        5.330362,
      ],
      [
        1569925911000,
        9.0392427,
        5.3740353,
      ],
      [
        1569925914000,
        8.0235143,
        4.4232337,
      ],
      [
        1569925917000,
        6.704468,
        4.956434,
      ],
      [
        1569925920000,
        12.847014,
        7.132084,
      ],
      [
        1569925923000,
        10.250679,
        5.2883527,
      ],
      [
        1569925926000,
        11.265679,
        6.7194733,
      ],
      [
        1569925929000,
        25.8066717,
        12.6344083,
      ],
      [
        1569925932000,
        19.082043,
        12.0798667,
      ],
      [
        1569925935000,
        11.6336923,
        6.2566243,
      ],
      [
        1569925938000,
        14.1195537,
        6.58356,
      ],
      [
        1569925941000,
        28.3482233,
        9.320233,
      ],
      [
        1569925944000,
        9.6276713,
        7.2527197,
      ],
      [
        1569925947000,
        8.9988897,
        5.2450233,
      ],
      [
        1569925950000,
        11.5536587,
        6.923977,
      ],
      [
        1569925953000,
        6.8708003,
        5.4996913,
      ],
      [
        1569925956000,
        12.643155,
        6.3621527,
      ],
      [
        1569925959000,
        6.0007993,
        4.2089593,
      ],
      [
        1569925962000,
        9.3029257,
        6.0087203,
      ],
      [
        1569925965000,
        6.289534,
        4.6231793,
      ],
      [
        1569925968000,
        48.1862773,
        10.886701,
      ],
      [
        1569925971000,
        53.39718,
        10.1797263,
      ],
      [
        1569925974000,
        12.9408257,
        5.5935597,
      ],
      [
        1569925977000,
        15.490988,
        7.7484633,
      ],
      [
        1569925980000,
        12.064842,
        5.9899273,
      ],
      [
        1569925983000,
        8.9376047,
        5.3846313,
      ],
      [
        1569925986000,
        15.2400457,
        6.3255237,
      ],
      [
        1569925989000,
        7.0000313,
        4.419969,
      ],
      [
        1569925992000,
        8.626277,
        4.918145,
      ],
      [
        1569925995000,
        6.1211967,
        5.206551,
      ],
      [
        1569925998000,
        11.1183877,
        5.6650257,
      ],
      [
        1569926001000,
        54.0118067,
        12.7852163,
      ],
      [
        1569926004000,
        20.6513923,
        8.155133,
      ],
      [
        1569926007000,
        7.3031753,
        5.6754963,
      ],
      [
        1569926010000,
        54.7066333,
        11.739725,
      ],
      [
        1569926013000,
        8.3417097,
        5.9647203,
      ],
    ],
  },
  min: 0,
  max: 61.7890567,
}
